import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`You can email me at `}<a parentName="p" {...{
        "href": "mailto:tyler@tylerobrien.dev."
      }}>{`tyler@tylerobrien.dev.`}</a>{` I don't have any active social medias, sorry!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      